export function uploadFile(
  url,
  file,
  progressListener,
  completeListener,
  errorListener,
) {
  const xhr = new XMLHttpRequest();
  xhr.upload.onprogress = progressListener;
  xhr.open('POST', url, true);

  const formData = new FormData();
  formData.append('file', file);

  xhr.onreadystatechange = function () {
    if (this.readyState !== 4) {
      return false;
    }

    if (this.status !== 200) {
      return errorListener();
    }
    completeListener(JSON.parse(this.response));
  };

  xhr.send(formData);
  return xhr;
}
